import { Placemark } from "@pbe/react-yandex-maps";
import React, { FC, ReactNode, useEffect, useRef } from "react";

const CPlaceMark: FC<CPaceMarkProps> = ({
    ymapsApi,
    iconImageHref,
    geometry,
    hintContent,
    iconImageSize = [30, 30],
    iconImageOffset = [-15, -15],
    handlePlacemarkClick = () => { },
    customComponent,
    zIndex,
    zIndexHover,
}) => {
    const placemarkRef = useRef<any | null>(null);

    let options: any = {
        iconImageSize,
        iconImageOffset: [-iconImageSize[0] / 2, -iconImageSize[1] / 2],
        zIndex,
        zIndexHover,
        iconLayout: "default#image"
    };

    // Если есть кастомный компонент, то layout с content
    if (customComponent) {
        options.iconLayout = "default#imageWithContent";
        options.iconContentLayout = customComponent;
    }

    // Если есть иконка — image layout
    if (iconImageHref) {
        options.iconImageHref = iconImageHref;
    }

    // Если ни того, ни другого — можно явно указать layout
    if (!iconImageHref && !customComponent) {
        options.iconLayout = "default#layout";
    }

    return (
        <Placemark
            geometry={geometry}
            modules={["geoObject.addon.hint"]}
            onClick={handlePlacemarkClick}
            options={options}
            properties={{
                hintContent: hintContent,
            }}
            instanceRef={(ref) => (placemarkRef.current = ref)}
        />
    );
};

export default React.memo(CPlaceMark);

interface CPaceMarkProps {
    ymapsApi?: any;
    iconImageHref: string;
    geometry?: [number, number];
    hintContent?: string;
    iconImageSize?: [number, number];
    iconImageOffset?: [number, number];
    handlePlacemarkClick?: () => void;
    customComponent?: any;
    zIndex?: number,
    zIndexHover?:number,
}